__turbopack_context__.v({
  "bar": "_0MjIgG_bar",
  "barcontainer": "_0MjIgG_barcontainer",
  "container": "_0MjIgG_container",
  "text": "_0MjIgG_text",
});
